<template>
  <div
    class="
      d-flex
      flex-column
      w-100
      h-100
      justify-content-center
      align-items-center
    "
  >
    <div
      class="p-4 p-lg-5"
      style="max-width:480px;"
    >
      <img
        src="@/assets/images/illustration/undraw_oops.svg"
        alt=""
        class="w-100"
      >
    </div>
    <div class="font-size-md text-center">
      <div v-html="wording" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {
      wording: ''
    };
  },
  created() {
    if (this.formID === '' && sessionStorage && sessionStorage.formID) {
      this.set({
        id: 'formID',
        value: sessionStorage.formID
      });
    }
    this.formCompany().then((res2) => {
      if (res2 && res2.success) {
        this.getWording();
      } else {
        this.wording = this.$t('errorMessage');
      }
    });
  },
  methods: {
    ...mapActions('formSetting', ['companyParam', 'formCompany']),
    ...mapMutations('formSetting', ['set']),
    getWording() {
      const body = {
        paramCode: 'ErrprPageWording'
      };
      this.companyParam(body).then((res) => {
        if (res && res.success) {
          this.wording = res.data[0].formParamValue;
        } else {
          this.wording = this.$t('errorMessage');
        }
      });
    }
  },
  computed: {
    ...mapState('formSetting', ['formID'])
  }
};
</script>
